import * as S from "./styles.ts";
import Table from "./Table";
import { TItem } from "./Table/TableCard";
import Button, { IButtonProps } from "@template/components/Button";
import LoadingSpinner from "@template/components/LoadingSpinner";
import Pagination from "@template/components/Pagination";
import { Ref } from "react";

export interface ICardTableProps {
  id?: string;
  label?: any;
  button?: IButtonProps;
  items: TItem[];
  pages?: number;
  onSelect: (key: string | number) => void;
  page: number;
  onPageChange: (page: number) => void;
  loading?: boolean;
  overrideContent?: any;
}

const CardTable = ({
  id,
  items = [],
  label,
  button,
  pages = 0,
  onSelect,
  onPageChange,
  page,
  loading,
  overrideContent,
}: ICardTableProps) => {
  if (overrideContent)
    return (
      <S.CardTableWrapper id={id}>
        <S.CardTableContent>
          <S.CardTableHeaderContainer $notFound={overrideContent}>
            {label && <S.CardTableHeaderLabel>{label}</S.CardTableHeaderLabel>}
          </S.CardTableHeaderContainer>
          <S.TableContentWrapper style={{ minHeight: 0 }}>
            {overrideContent}
          </S.TableContentWrapper>
        </S.CardTableContent>
      </S.CardTableWrapper>
    );
  return (
    <S.CardTableWrapper id={id}>
      <S.CardTableContent>
        <S.CardTableHeaderContainer>
          {label && <S.CardTableHeaderLabel>{label}</S.CardTableHeaderLabel>}
          {button && (
            <Button
              size="md"
              {...button}
            >
              {button.children}
            </Button>
          )}
        </S.CardTableHeaderContainer>
        <S.TableContentWrapper>
          {loading && (
            <S.LoaderWrapper>
              <LoadingSpinner height={40} />
            </S.LoaderWrapper>
          )}
          <Table
            items={items}
            onSelect={onSelect}
          />
        </S.TableContentWrapper>
        <S.CardTableFooterContainer>
          <Pagination
            pages={pages}
            selectedPage={page}
            onChange={onPageChange}
          />
        </S.CardTableFooterContainer>
      </S.CardTableContent>
    </S.CardTableWrapper>
  );
};

export default CardTable;
